<template>
	<component :is="tag" :style="style"><icon-button name="trash" @click="invokeDelete" class="del-butt"></icon-button></component>
</template>

<script setup lang="ts">
import {injectCellAPI, rowObjectKey} from "./AgendaUtils";
import {computed, type CSSProperties, inject} from "vue";
import type {DataColumn} from "@t/fd/layout/Agenda.ts";
import IconButton from "@fd/helpers/IconButton.vue";

const props = withDefaults(defineProps<{
	object: object,
	col: DataColumn,
	tag?: string
}>(), { tag: "td" });

const style = computed<CSSProperties>(() => {
	if (props.tag === "td") return { textAlign: "center" };
	return {}
});
const api = injectCellAPI();
const rowKey = inject(rowObjectKey, null);

function invokeDelete(e:MouseEvent) {
	api.action("delete", rowKey, e);
}

</script>

<style>
.del-butt {
	opacity: 0.5;
	&:hover {
		opacity: 1;
		color: var(--red);
	}
}
</style>
